<template>
  <div>
    <div class="news_page_banner_out">
      <div class="container">
        <dl class="all_page_banner_txt">
          <dt>新闻资讯</dt>
          <dd>news &nbsp;&nbsp; information</dd>
        </dl>
      </div>
    </div>

    <div style="padding: 0 0 1%;">
      <ul class="container news_page_tab clearfix font-title">
        <li :class="allselect?'active':''">
          <a @click="typeclick()" href="javascript:;">全部新闻</a>
        </li>
        <li v-for="type in typeList" v-if="type.Name=='公司新闻'"  :class="type.Selected?'active':''">
          <a href="javascript:;" @click="typeclick(type)">{{type.Name}}</a>
        </li>
      </ul>
    </div>
    <div class="container">
      <div class="row">
        <ul class="news_page_list">
          <li class="transition_03" v-for="newitem in newsList">
            <router-link :to="{name:'details',query:{id:newitem.id}}" target="_blank"  tag="a">
              <!-- <a target="_blank" @click="newsclick(newitem.id)"> -->
              <div class="img_out transition_03">
                <div class="img">
                  <img class="transition_03" :src="newitem.img" alt />
                </div>
              </div>
              <div class="txt transition_03">
                <h6 class="font-title">{{newitem.title}}</h6>
                <span class="font-note">[{{newitem.typename}}]</span>
                <p class="font-text">{{newitem.subTitle|ellipsis}}</p>
              </div>
              <div class="time transition_03">
                <dl>
                  <dt>{{newitem.pubDate==null?newitem.createtime:newitem.pubDate| monthdatData}}</dt>
                  <dt>{{newitem.pubDate==null?newitem.createtime:newitem.pubDate| yearData}}</dt>
                  <!-- <dt>11-29</dt>
                  <dd>2019</dd>-->
                </dl>
                <em class="transition_03">
                  <i></i>
                </em>
              </div>
              <!-- </a> -->
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="container clearfix page_paging font-title">
      <ul class="button_name clearfix">
        <Page
          :total="totalcount"
          show-total
          @on-change="change"
          :current="PagaIndex"
          :page-size="pageSize"
        />
      </ul>
      <ul class="button_next_prev clearfix">
        <li>
          <a class="prev" @click="page(-1)">
            <span class="transition_02"></span>
          </a>
        </li>
        <li>
          <a class="next" @click="page(1)">
            <span class="transition_02"></span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import "../../static/css/swiper.min.css";
import "../../static/css/nav.css";
import "../../static/css/bootstrap.min.css";
import "../../static/css/animate.min.css";
import "../../static/css/common.css";
import "../../static/css/style.css";
import { WOW } from "wowjs";
import Qs from "qs";

import moment from "moment";
import axios from "@/libs/api.request";
export default {
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 80) {
        return value.slice(0, 80) + "...";
      }
      return value;
    },
    yearData(value) {
      if (value != null) {
        return moment(value).format("YYYY");
      }
    },
    monthdatData(value) {
      if (value != null) {
        return moment(value).format("MM-DD");
      }
    }
  },
  data() {
    return {
      newsList: [
        {
          id: 1,
          img: "http://192.168.1.124:8099/img/newsimage/img-5.jpg",
          title: "我公司获邀参加第二届全国卫生职业院校教师检验技能竞赛",
          typename: "公司新闻",
          createtime: "2020-03-05",
          content:
            "由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。"
        },
        {
          id: 2,
          img: "http://192.168.1.124:8099/img/newsimage/img-5.jpg",
          title: "我公司获邀参加第二届全国卫生职业院校教师检验技能竞赛",
          typename: "公司新闻",
          createtime: "2020-03-05",
          content:
            "由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。"
        },
        {
          id: 3,
          img: "http://192.168.1.124:8099/img/newsimage/img-5.jpg",
          title: "我公司获邀参加第二届全国卫生职业院校教师检验技能竞赛",
          typename: "公司新闻",
          createtime: "2020-03-05",
          content:
            "由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。"
        },
        {
          id: 4,
          img: "http://192.168.1.124:8099/img/newsimage/img-5.jpg",
          title: "我公司获邀参加第二届全国卫生职业院校教师检验技能竞赛",
          typename: "公司新闻",
          createtime: "2020-03-05",
          content:
            "由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。"
        },
        {
          id: 5,
          img: "http://192.168.1.124:8099/img/newsimage/img-5.jpg",
          title: "我公司获邀参加第二届全国卫生职业院校教师检验技能竞赛",
          typename: "公司新闻",
          createtime: "2020-03-05",
          content:
            "由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。"
        },
        {
          id: 6,
          img: "http://192.168.1.124:8099/img/newsimage/img-5.jpg",
          title: "我公司获邀参加第二届全国卫生职业院校教师检验技能竞赛",
          typename: "公司新闻",
          createtime: "2020-03-05",
          content:
            "由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。"
        },
        {
          id: 7,
          img: "http://192.168.1.124:8099/img/newsimage/img-5.jpg",
          title: "我公司获邀参加第二届全国卫生职业院校教师检验技能竞赛",
          typename: "公司新闻",
          createtime: "2020-03-05",
          content:
            "由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。由全国卫生职业教育教学指导委员会医学检验分会组织的“第二届全国卫生职业院校教师检验技能竞赛”，于2017年11月11日至14日在美丽的山城重庆召开，我公司受邀参加该次盛会，并获主办方办法特别贡献奖。"
        }
      ],
      typeList: [],
      //当前页码
      PagaIndex: 1,
      //每页数量
      pageSize: 5,
      //新闻类别
      newsType: ["Company", "Industry"],
      //总记录数
      totalcount: 100,
      allselect: true,
      type: ""
    };
  },
  methods: {
    typeData() {
      let data = {
        DataDictionaryCode: "NewsType"
      };
      var posturl =
        this.config.baseUrl.pro + "/DataDictionary/ApiGetDataDictionaryOptions";
      axios
        .request({
          url: posturl,
          method: "GET",
          changeOrigin: true, //允许跨域2
          data: data
        })
        .then(resp => {
          if (resp.status === 200) {
            this.newst=resp.data;
            var lists = [];
            for (var i = 0; i < this.newst.length; i++) {
              if (
                this.newst[i].Code != "Server" &&
                this.newst[i].Code != "CoreStrengths"
              ) {
                this.newst[i].Selected = false;
                this.typeList.push(this.newst[i]);
                lists.push(this.newst[i].Code);
              }
            }
            this.newsType = lists;

            this.type = this.$route.query.type;
            if (this.type != undefined && this.type != "") {
              for (var i = 0; i < this.newsType.length; i++) {
                if (this.newsType[i].Code == this.type) {
                  this.typeclick(this.newsType[i]);
                  break;
                }
              }
            }
            this.getData();
          }
        })
        .catch(err => {
          console.log(err);
          this.$Message.info("新闻列表查询失败" + err);
        });
    },
    ///数据加载
    getData() {
      let data = {
        PagaIndex: this.PagaIndex,
        pageCount: this.pageSize,
        newsType: this.newsType
      };
      var posturl = this.config.baseUrl.pro + "/Base_News/apiGetNewsList";
      axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域2
          data: data
        })
        .then(resp => {
          if (resp.status === 200) {
            this.newsList = resp.data.result.data;
            this.totalcount = resp.data.result.total;

            console.log(this.newsList);
          }
        })
        .catch(err => {
          console.log(err);
          this.$Message.info("新闻列表查询失败");
        });
    },
    ///切换新闻分类
    typeclick(type) {
      for (var i = 0; i < this.typeList.length; i++) {
        this.typeList[i].Selected = false;
      }
      if (type == undefined) {
        var lists = [];
        for (var i = 0; i < this.typeList.length; i++) {
          this.typeList[i].Selected = false;
          lists.push(this.typeList[i].Code);
        }
        this.allselect = true;
        this.newsType = lists;
      } else {
        type.Selected = true;
        this.allselect = false;
        this.newsType = [type.Code];
      }
      this.pageIndex = 1;
      this.getData();
    },
    //当页码变化
    //分页
    change(page) {
      this.PagaIndex = page;
      this.getData();
    },
    page(num) {
      var ind = this.PagaIndex + num;
      if ((ind - 1) * this.pageSize < this.totalcount && ind >= 1) {
        this.PagaIndex = ind;
        this.getData();
      }
    }
  },
  mounted() {
    this.typeData();
  }
};
</script>



// WEBPACK FOOTER //
// src/view/newslist.vue